import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-sample-application',
    templateUrl: './sample-application.component.html',
    styleUrls: ['./sample-application.component.scss'],
    standalone: false
})
export class SampleApplicationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
